// extracted by mini-css-extract-plugin
export var resume = "ResumePreview-module--resume--377zF";
export var backdrop = "ResumePreview-module--backdrop--2Gdi9";
export var page = "ResumePreview-module--page--n_ChU";
export var meta = "ResumePreview-module--meta--weRsZ";